<template>
  <div class="x-tablelist-view" data-automation="deviceAccess">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="seach"
      @search="seach"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addDevice from './template/addDevice';
import devDomains from './template/devDomains';
export default {
  components: {
    addDevice,
    devDomains
  },
  data() {
    return {
      // missOnline: true,
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'type',
          placeholder: this.$t('HT.rules.addDevice.type')
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          right: true,
          hidden: !this.$hasModule(23),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addDevice.type'),
          prop: 'type',
          tooltip: true
        },
        {
          label: this.$t('HT.deviceAccess.domains'),
          tooltip: true,
          render: (h, params) => {
            return h(devDomains, {
              props: {
                list: params.domains
              }
            });
          }
        },
        {
          label: this.$t('HT.deviceAccess.manufacturer'),
          prop: 'manufacturer',
          tooltip: true
        },
        {
          label: this.$t('HT.remark'),
          prop: 'remark',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(23),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.edit'),
                  this.$t('HT.deviceAccess.on'),
                  this.$t('HT.deviceAccess.off'),
                  this.$t('HT.delete')
                ],
                colors: ['#0087ff'],
                className: [
                  '',
                  params.online ? 'no-click' : '',
                  !params.online ? 'no-click' : '',
                  ''
                ],
                event: ['edit', 'release', 'offline', 'del']
              },
              on: {
                edit: () => {
                  this.showEdit(params);
                },
                release: () => {
                  if (params.online == false) {
                    const title = this.$t('HT.deviceAccess.on.placeholder');
                    this.$uxModal.show({
                      title,
                      confirm: () => {
                        this.release(params.id);
                      }
                    });
                  }
                },
                offline: () => {
                  if (params.online == true) {
                    const title = this.$t('HT.deviceAccess.off.placeholder');
                    this.$uxModal.show({
                      title,
                      confirm: () => {
                        this.offline(params.id);
                      }
                    });
                  }
                },
                del: () => {
                  if (params.online) {
                    this.$uxModal.hide();
                    this.$uxMessage.warning(this.$t('HT.deviceAccess.on.warning'));
                  } else {
                    const title = this.$t('HT.deviceAccess.del');
                    const content = this.$t('HT.deviceAccess.del.content');
                    this.$uxModal.show({
                      title,
                      content,
                      confirm: () => {
                        this.delList(params.id);
                      }
                    });
                  }
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      applyList: []
    };
  },
  mounted() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.device.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.device.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.device.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getList(this.filter);
          if (this.tableData.list.length === 1) {
            this.filter.page = 1;
          }
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.device.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 上线
     */
    release(id) {
      this.$uxLoading.show();
      this.$api.device.release(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.onSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 下线
     */
    offline(id) {
      this.$uxLoading.show();
      this.$api.device.release(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.offSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.deviceAccess.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addDevice, {});
        },
        confirm: (data) => {
          let res = JSON.parse(JSON.stringify(data));
          res.domains = res.domains.join(';');
          this.addList(res);
        }
      });
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.deviceAccess.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addDevice, {
            props: { data: params },
            on: {
              confirm: (data) => {
                this.putList(data);
              }
            }
          });
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
